import { jumboMediaAPI } from "./service";

// Direct-to-S3 upload target, served by the backend from `BucketName` / `AwsRegion` /
// `AwsAccessKeyId` in JumboMedia.Web/Web.config (+ its Debug/Test/Release transforms).
//
// The browser PUTs straight to S3 and the backend only HMAC-signs the policy without inspecting it,
// so whatever this returns IS the upload destination. It used to be a hardcoded bucket table in
// FineUploaderComponent keyed off window.location.origin, which meant the deployed hostname decided
// the bucket rather than config — and any origin the table did not name fell through to the
// PRODUCTION bucket. Now the environment ladder is purely the config ladder: local dev =
// jumbomedia-dev (matching the jumbomedia-dev catalog), test = jumbomedia-test, prod =
// jumbomedia-production.
//
// AccessKeyId is the AWS key id, not the secret; the secret never leaves the backend. The id was
// already public — it shipped hardcoded in this bundle and rides on every upload request.
export type UploadConfigT = {
  BucketName: string | null;
  Region: string | null;
  AccessKeyId: string | null;
};

export const uploadConfigAPI = jumboMediaAPI.injectEndpoints({
  endpoints: (build) => ({
    getUploadConfig: build.query<UploadConfigT, void>({
      query: () => ({ url: "/api/UploadConfig/Get" }),
    }),
  }),
});

export const { useGetUploadConfigQuery } = uploadConfigAPI;
